import classes from "./ContactSection.module.css";

function ContactSection() {
  const contactEmail = "support@tabu-fy.com";

  return (
    <section className={classes.contactSection}>
      <div className={classes.container}>
        <h2 className={classes.title}>צור קשר</h2>
        <p className={classes.subtitle}>יש לך שאלה? אנחנו כאן בשבילך</p>

        <div className={classes.cardsContainer}>
          <a
            href={`mailto:${contactEmail}?subject=פנייה מאתר Tabufy`}
            className={classes.card}
          >
            <div className={classes.iconWrapper}>
              <svg
                className={classes.icon}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 6L12 13L2 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h3>שלח לנו מייל</h3>
            <p className={classes.cardDescription}>נשמח לענות על כל שאלה</p>
            <span className={classes.emailLink}>{contactEmail}</span>
            <div className={classes.responseTime}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <span>זמן תגובה: עד 24 שעות</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
